package org.example.project.ui

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.example.project.model.User
import org.jetbrains.compose.resources.painterResource
import battleships.shared.generated.resources.Res
import battleships.shared.generated.resources.ocean
import coil3.compose.AsyncImage
import kotlinx.coroutines.delay
import org.example.project.viewmodel.GameViewModel

@Composable
fun HomeScreen(
    user: User,
    onFindMatch: () -> Unit,
    onLeaderboard: () -> Unit,
    onLogout: () -> Unit = {},
    onSettings: () -> Unit = {},
    viewModel: GameViewModel,
    rank: Int
) {

    var showSettings by remember {
        mutableStateOf(false)
    }

    LaunchedEffect(Unit) {
        while (true) {
            viewModel.refreshPlayersInQueue()
            delay(5000)
        }
    }
    BoxWithConstraints(
        modifier = Modifier.fillMaxSize()
    ) {

        val isMobile = maxWidth < 700.dp

        Image(
            painter = painterResource(
                Res.drawable.ocean
            ),
            contentDescription = null,
            modifier = Modifier.fillMaxSize(),
            contentScale = ContentScale.Crop
        )

        Column(
            modifier = Modifier
                .fillMaxSize()
                .verticalScroll(
                    rememberScrollState()
                )
                .padding(
                    if (isMobile)
                        16.dp
                    else
                        24.dp
                ),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            Spacer(
                modifier = Modifier.height(40.dp)
            )

            Text(
                text = "BATTLESHIPS",
                color = Color.White,
                fontSize =
                    if (isMobile)
                        36.sp
                    else
                        54.sp,
                fontWeight = FontWeight.Bold
            )

            Text(
                text = "CODE • ATTACK • CONQUER",
                color = Color(0xFF00E5FF),
                fontSize = 18.sp
            )

            if (isMobile) {

                Spacer(
                    modifier = Modifier.height(16.dp)
                )

                Row(
                    horizontalArrangement =
                        Arrangement.spacedBy(12.dp)
                ) {

                    Button(
                        onClick = onLogout,
                        colors =
                            ButtonDefaults.buttonColors(
                                containerColor =
                                    Color(0xAA001B33)
                            )
                    ) {
                        Text("LOGOUT")
                    }

                    Button(
                        onClick = {
                            showSettings = true
                        },
                        colors =
                            ButtonDefaults.buttonColors(
                                containerColor =
                                    Color(0xAA001B33)
                            )
                    ) {
                        Text("SETTINGS")
                    }
                }
            }

            Spacer(modifier = Modifier.height(10.dp))

            Surface(
                modifier = Modifier.wrapContentSize(),
                color = Color(0xCC001B33),
                shape = RoundedCornerShape(12.dp),
                border = BorderStroke(
                    2.dp,
                    Color(0xFF00CFFF)
                ),
                shadowElevation = 8.dp
            ) {
                Row(
                    modifier = Modifier.padding(
                        horizontal = 18.dp,
                        vertical = 12.dp
                    ),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center
                ) {
                    Column(
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Text(
                            text = "COMMANDERS SEARCHING: ${viewModel.playersInQueue}",
                            fontSize = 18.sp,
                            color = Color(0xFF00CFFF),
                            fontWeight = FontWeight.Bold
                        )
                        Spacer(modifier = Modifier.height(4.dp))
                        Text(
                            text = "Hint: Refresh to update",
                            fontSize = 11.sp,
                            fontWeight = FontWeight.ExtraBold,
                            color = Color.White
                        )
                    }
                }
            }

            Spacer(modifier = Modifier.height(30.dp))

            ProfileCard(
                user = user,
                rank = rank,
                isMobile = isMobile
            )

            Spacer(
                modifier = Modifier.height(32.dp)
            )

            if (isMobile) {

                Column(
                    verticalArrangement =
                        Arrangement.spacedBy(20.dp)
                ) {
                    ActionCard(
                        title = "FIND MATCH",
                        description =
                            viewModel.matchMakingText,
                        buttonText = "PLAY NOW",
                        onClick = onFindMatch,
                        isMobile = true
                    )

                    ActionCard(
                        title = "LEADERBOARD",
                        description =
                            "See top commanders\nand their scores",
                        buttonText = "VIEW LEADERBOARD",
                        onClick = onLeaderboard,
                        isMobile = true
                    )
                }

            } else {

                Row(
                    horizontalArrangement =
                        Arrangement.spacedBy(32.dp)
                ) {

                    ActionCard(
                        title = "FIND MATCH",
                        description =
                            viewModel.matchMakingText,
                        buttonText = "PLAY NOW",
                        onClick = onFindMatch,
                        isMobile = false
                    )

                    ActionCard(
                        title = "LEADERBOARD",
                        description =
                            "See top commanders\nand their scores",
                        buttonText = "VIEW LEADERBOARD",
                        onClick = onLeaderboard,
                        isMobile = false
                    )
                }
            }
        }

        if(!isMobile) {

            Button(
                onClick = onLogout,
                modifier = Modifier
                    .align(Alignment.TopStart)
                    .padding(20.dp),
                colors =
                    ButtonDefaults.buttonColors(
                        containerColor =
                            Color(0xAA001B33)
                    )
            ) {
                Text("LOGOUT")
            }

            Button(
                onClick = { showSettings = true },
                modifier = Modifier
                    .align(Alignment.TopEnd)
                    .padding(20.dp),
                colors =
                    ButtonDefaults.buttonColors(
                        containerColor =
                            Color(0xAA001B33)
                    )
            ) {
                Text("SETTINGS")
            }
        }

        if (showSettings) {

            SettingsOverlay(
                user = user,
                soundEnabled = viewModel.soundEnabled,
                animationsEnabled = viewModel.animationsEnabled,
                showCoordinates = viewModel.showCoordinates,
                onSoundChanged = viewModel::setSoundEnabled,
                onAnimationsChanged = viewModel::setAnimationsEnabled,
                onCoordinatesChanged = viewModel::setShowCoordinates,
                onVolumeChanged = viewModel::setVolume,
                volume = viewModel.volume,

                onClose = {
                    showSettings = false
                },

                onLogout = onLogout
            )
        }
    }
}
@Composable
private fun ProfileCard(
    user: User,
    isMobile: Boolean,
    rank : Int
) {


    Card(
        modifier = if(isMobile){
            Modifier
                .fillMaxWidth()
                .height(
                    if (isMobile)
                        180.dp
                    else
                        220.dp
                )
        }else {
            Modifier
                .width(752.dp)
                .height(
                    if (isMobile)
                        180.dp
                    else
                        220.dp
                )
        },
        colors =
            CardDefaults.cardColors(
                containerColor =
                    Color(0xCC001B33)
            ),
        border =
            BorderStroke(
                2.dp,
                Color(0xFF00E5FF)
            ),
        shape =
            RoundedCornerShape(24.dp)
    ) {

        Row(
            modifier = Modifier
                .fillMaxSize()
                .padding(24.dp),
            verticalAlignment =
                Alignment.CenterVertically
        ) {

            AsyncImage(
                model = user.photoUrl,
                contentDescription = "Profile Picture",
                modifier = Modifier
                    .size(if (isMobile) 80.dp else 120.dp)
                    .clip(CircleShape),
                contentScale = ContentScale.Crop
            )

            Spacer(
                modifier = Modifier.width(32.dp)
            )

            Column {

                Text(
                    text = user.username,
                    color = Color.White,
                    fontSize =
                        if (isMobile)
                            24.sp
                        else
                            36.sp,
                    fontWeight = FontWeight.Bold
                )

                Text(
                    text = "Commander",
                    color = Color(0xFF00E5FF),
                    fontSize = 22.sp
                )


                Spacer(
                    modifier = Modifier.height(24.dp)
                )

                if (isMobile) {

                    FlowRow(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceEvenly,
                        verticalArrangement = Arrangement.spacedBy(12.dp)
                    ) {
                        StatItem("RANK", "#$rank",isMobile)
                        StatItem("WINS", user.wins.toString(),isMobile)
                        StatItem("LOSSES", user.losses.toString(),isMobile)
                        StatItem("SCORE", user.score.toString(),isMobile)
                    }

                } else {

                    Row(
                        horizontalArrangement =
                            Arrangement.spacedBy(40.dp)
                    ) {

                        StatItem("RANK", "#$rank",isMobile)
                        StatItem("WINS", user.wins.toString(),isMobile)
                        StatItem("LOSSES", user.losses.toString(),isMobile)
                        StatItem("SCORE", user.score.toString(),isMobile)
                    }
                }
            }
        }
    }
}
@Composable
private fun StatItem(
    title: String,
    value: String,
    isMobile: Boolean
) {

    Column(
        horizontalAlignment =
            Alignment.CenterHorizontally
    ) {

        Text(
            title,
            color = Color.LightGray,
            fontSize = if(isMobile){
                14.sp
            }else
            {
                22.sp
            },
            fontWeight = FontWeight.Bold
        )

        Text(
            value,
            color = Color(0xFF00E5FF),
            fontWeight = FontWeight.Bold,
            fontSize = if(isMobile){
                18.sp
            }else{
                28.sp
            }
        )
    }
}
@Composable
private fun ActionCard(
    title: String,
    description: String,
    buttonText: String,
    onClick: () -> Unit,
    isMobile: Boolean
) {

    Card(
        modifier = if(isMobile){
            Modifier
                .fillMaxWidth()
                .height(
                    if (isMobile)
                        260.dp
                    else
                        380.dp
                )
        } else{
            Modifier
                .width(360.dp)
                .height(
                    if (isMobile)
                        260.dp
                    else
                        380.dp
                )
        },
        colors =
            CardDefaults.cardColors(
                containerColor =
                    Color(0xCC001B33)
            ),
        border =
            BorderStroke(
                2.dp,
                Color(0xFF00E5FF)
            ),
        shape =
            RoundedCornerShape(24.dp)
    ) {

        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(24.dp),
            horizontalAlignment =
                Alignment.CenterHorizontally,
            verticalArrangement =
                Arrangement.SpaceEvenly
        ) {

            Text(
                title,
                color = Color.White,
                fontSize =
                    if (isMobile)
                        24.sp
                    else
                        32.sp,
                fontWeight = FontWeight.Bold
            )

            Text(
                description,
                color = Color(0xFF00E5FF),
                fontSize = 18.sp,
                textAlign = TextAlign.Center
            )

            Button(
                onClick = onClick,
                modifier = Modifier
                    .fillMaxWidth()
                    .height(60.dp),
                colors =
                    ButtonDefaults.buttonColors(
                        containerColor =
                            Color(0xFF00C8FF)
                    ),
                shape =
                    RoundedCornerShape(30.dp)
            ) {

                Text(
                    buttonText,
                    color = Color.Black,
                    fontWeight = FontWeight.Bold
                )
            }
        }
    }
}
